import classnames from 'classnames';
import React, { useContext } from 'react';
import { ListerContext } from '../../listerContext';
import FacetsToggler from '../facetsToggler/facetsTogglerContainer';
import GridToggler from '../gridToggler/gridTogglerContainer';
import Sort from '../sort/sortContainer';
import controlsStyles from './controls.module.pcss';

function Controls(): React.ReactElement {
  const [{ isFacetsDisplayed }] = useContext(ListerContext);

  return (
    <div className={controlsStyles.controls}>
      <div
        className={classnames(controlsStyles['controls__facets-toggler'], {
          [controlsStyles['controls__facets-toggler--hidden']]: !isFacetsDisplayed
        })}
      >
        <FacetsToggler />
      </div>
      <div className={controlsStyles['controls__grid-toggler']}>
        <GridToggler />
      </div>
      <div className={controlsStyles['controls__sort']}>
        <Sort />
      </div>
    </div>
  );
}

export default Controls;
